import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import { merge } from "lodash";
import HelperText from "../../../components/atoms/HelperText";
import { Descriptions } from "../constants/descriptions";
import {
  AffectedStatusOptions,
  AlleleOriginOptions,
  CLINICAL_FEATURES_AFFECTED_STATUS,
  CollectionMethodOptions,
  StructVarMethodTypeOptions,
} from "../constants/form-constants";
import { ObservedInType } from "../types/types";
import { validationErrors } from "../constants/validationErrors";
import {
  Input,
  FormGroup,
  InputHelperText,
  Select,
  Label,
  Textarea,
} from "../../../components/atoms/Form";

const ObservedIn = (props) => {
  const {
    onChangeObserveIn,
    setTouched,
    observedIn,
    setErrors,
    touched,
    errors,
    handleBlur,
  } = props;
  const [state, setState] = useState([
    {
      affectedStatus: "",
      alleleOrigin: "",
      clinicalFeatures: [
        // { db: "", id: "", name: "", clinicalFeaturesAffectedStatus: "" },
      ],
      clinicalFeaturesComment: "",
      collectionMethod: "",
      numberOfIndividuals: "",
      structVarMethodType: "",
    },
  ]);
  useEffect(() => {
    if (observedIn) {
      // const defaults = observedIn.map((obj) => ({
      //   ...obj,
      //   clinicalFeatures: obj.clinicalFeatures || [],
      //   affectedStatus: obj.affectedStatus || "",
      //   alleleOrigin: obj.affectedStatus || "",
      //   clinicalFeaturesComment: obj.clinicalFeaturesComment || "",
      //   collectionMethod: obj.collectionMethod || "",
      //   numberOfIndividuals: obj.numberOfIndividuals || 0,
      //   structVarMethodType: obj.structVarMethodType || "",
      // }));
      const newState = observedIn.map(() => {
        return {
          affectedStatus: "",
          alleleOrigin: "",
          clinicalFeatures: [],
          clinicalFeaturesComment: "",
          collectionMethod: "",
          numberOfIndividuals: "",
          structVarMethodType: "",
        };
      });
      merge(newState, observedIn);
      setState(newState);
    }
  }, []);

  const handleRemoveObserveln = (index) => {
    const newstate = [...state];
    newstate.splice(index, 1);
    setState(newstate);
    const newErrors = { ...errors };
    newErrors.observedIn.splice(index, 1);
    setErrors(newErrors);
    const newTouched = { ...touched };
    newTouched.observedIn.splice(index, 1);
    setTouched(newTouched);
  };

  const handleAddObserveln = () => {
    const newstate = [...state];
    newstate.push({
      affectedStatus: "",
      alleleOrigin: "",
      clinicalFeatures: [],
      clinicalFeaturesComment: "",
      collectionMethod: "",
      numberOfIndividuals: "",
      structVarMethodType: "",
    });
    setState(newstate);
    const newErrors = { ...errors };
    newErrors.observedIn.push({
      affectedStatus: validationErrors.emptyStringError,
      alleleOrigin: validationErrors.emptyStringError,
      collectionMethod: validationErrors.emptyStringError,
      numberOfIndividuals: "",
      clinicalFeatures: [],
    });
    setErrors(newErrors);
    const newTouched = { ...touched };
    newTouched.observedIn.push({
      affectedStatus: false,
      alleleOrigin: false,
      collectionMethod: false,
      numberOfIndividuals: false,
      clinicalFeatures: [],
    });
    setTouched(newTouched);
  };

  const handleBlurForAffectedStatus = (e, index, clinindex) => {
    const { name, value } = e.target;
    const newErrors = { ...errors };
    const newTouhed = { ...touched };
    if (value !== "") {
      newErrors.observedIn[index].clinicalFeatures[clinindex][name] = "";
    } else {
      newErrors.observedIn[index].clinicalFeatures[clinindex][name] =
        validationErrors.emptyStringError;
    }
    newTouhed.observedIn[index].clinicalFeatures[clinindex][name] = true;
    setTouched(newTouhed);
    setErrors(newErrors);
  };

  const handleAddClick = (index) => {
    const newstate = [...state];
    newstate[index].clinicalFeatures.push({
      db: "",
      id: "",
      name: "",
      clinicalFeaturesAffectedStatus: "",
    });
    setState(newstate);

    const newErrors = { ...errors };
    newErrors.observedIn[index].clinicalFeatures.push({
      db: validationErrors.emptyStringError,
      id: validationErrors.emptyStringError,
      name: validationErrors.emptyStringError,
      clinicalFeaturesAffectedStatus: validationErrors.emptyStringError,
    });
    setErrors(newErrors);
    const newTouched = { ...touched };
    newTouched.observedIn[index].clinicalFeatures.push({
      clinicalFeaturesAffectedStatus: false,
      db: false,
      id: false,
      name: false,
    });
    setTouched(newTouched);
  };
  useEffect(() => {
    handleAddClick(0);
  }, []);
  const handleRemoveClick = (index, clinindex) => {
    const list = [...state];
    list[index].clinicalFeatures.splice(clinindex, 1);
    setState(list);
    const newErrors = { ...errors };
    newErrors.observedIn[index].clinicalFeatures.splice(clinindex, 1);
    setErrors(newErrors);
    const newTouched = { ...touched };
    newTouched.observedIn[index].clinicalFeatures.splice(clinindex, 1);
    setTouched(newTouched);
  };

  const onValueChange = (e, index, clindex = null) => {
    const { name } = e.target;
    const { value } = e.target;

    if (name === "numberOfIndividuals") {
      if (
        // eslint-disable-next-line no-restricted-globals
        isNaN(value) ||
        !Number.isInteger(Number(value)) ||
        value.includes(".")
      ) {
        const list = [...state];
        list[index][name] = value;
        setState(list);
        return;
      }
      if (value === "") {
        const list = [...state];
        list[index][name] = value;
        setState(list);
        return;
      }
      const list = [...state];
      list[index][name] = parseInt(value, 10);
      setState(list);
      return;
    }
    if (
      name === "db" ||
      name === "id" ||
      name === "name" ||
      name === "clinicalFeaturesAffectedStatus"
    ) {
      const newstate = [...state];
      state[index].clinicalFeatures[clindex][name] = value;
      setState(newstate);

      const newErrors = { ...errors };
      if (value !== "" && (name === "db" || name === "id")) {
        newErrors.observedIn[index].clinicalFeatures[clindex].name = "";
      }
      if (value !== "" && name === "name") {
        newErrors.observedIn[index].clinicalFeatures[clindex].db = "";
        newErrors.observedIn[index].clinicalFeatures[clindex].id = "";
      }
      if (value === "" && name === "name") {
        if (state[index].clinicalFeatures[clindex].db === "") {
          newErrors.observedIn[index].clinicalFeatures[clindex].db =
            validationErrors.emptyStringError;
        }
        if (state[index].clinicalFeatures[clindex].id === "") {
          newErrors.observedIn[index].clinicalFeatures[clindex].id =
            validationErrors.emptyStringError;
        }
      }
      if (value === "" && name !== "name") {
        if (name === "db" && state[index].clinicalFeatures[clindex].id === "") {
          newErrors.observedIn[index].clinicalFeatures[clindex].id =
            validationErrors.emptyStringError;
          if (state[index].clinicalFeatures[clindex].name === "") {
            newErrors.observedIn[index].clinicalFeatures[clindex].name =
              validationErrors.emptyStringError;
          }
        }

        if (name === "id" && state[index].clinicalFeatures[clindex].db === "") {
          newErrors.observedIn[index].clinicalFeatures[clindex].db =
            validationErrors.emptyStringError;
          if (state[index].clinicalFeatures[clindex].name === "") {
            newErrors.observedIn[index].clinicalFeatures[clindex].name =
              validationErrors.emptyStringError;
          }
        }
      }

      setErrors(newErrors);
    } else {
      const list = [...state];
      list[index][name] = value;
      setState(list);
    }
  };

  useEffect(() => {
    onChangeObserveIn([...state]);
  }, [state]);

  return (
    <div className="tw-pt-8 tw-pb-8">
      <div className="tw-text-2xl">Observed In</div>
      {/* <div className="tw-text-sm">{Descriptions.observedIn}</div> */}
      {state.length === 0 && (
        <div className="tw-flex tw-m-4 tw-justify-center">
          <button
            type="button"
            onClick={() => handleAddObserveln(0)}
            className="btn btn-success"
          >
            <FontAwesomeIcon
              icon={faPlus}
              size="md"
              fixedWidth={true}
              className="tw-px-1 tw-text-white"
            />
            Add Observed In
          </button>
        </div>
      )}
      {state.map((x, index) => {
        const key = `${index}-${state}`;
        return (
          <div className="tw-pt-6" key={key}>
            <div className="tw-flex tw-flex-wrap tw-px-4 tw-py-4 tw-bg-gray-100">
              <div className="tw-flex tw-w-11/12">
                <FormGroup className="tw-w-6/12 tw-mr-4">
                  <Label text="Affected Status" isRequired={true} />
                  <Select
                    type="select"
                    onBlur={(e) => handleBlur(e, index)}
                    id={`affectedStatus${index}`}
                    name="affectedStatus"
                    onChange={(e) => onValueChange(e, index)}
                    value={x.affectedStatus}
                  >
                    <option value="" />
                    {AffectedStatusOptions.map((value) => (
                      <option
                        key={`${value}-${state[index].clinicalFeatures}`}
                        value={value}
                      >
                        {value}
                      </option>
                    ))}
                  </Select>
                  {touched.observedIn[index].affectedStatus &&
                  errors.observedIn[index].affectedStatus ? (
                    <InputHelperText type="error">
                      {errors.observedIn[index].affectedStatus}
                    </InputHelperText>
                  ) : (
                    <InputHelperText>
                      {Descriptions.affectedStatus}
                    </InputHelperText>
                  )}
                </FormGroup>
                <FormGroup className="tw-w-6/12">
                  <Label text="Allele Origin" isRequired={true} />
                  <Select
                    type="select"
                    id={`alleleOrigin${index}`}
                    name="alleleOrigin"
                    onChange={(e) => onValueChange(e, index)}
                    onBlur={(e) => handleBlur(e, index)}
                    value={x.alleleOrigin}
                  >
                    <option value="" />
                    {AlleleOriginOptions.map((value) => (
                      <option key={value} value={value}>
                        {value}
                      </option>
                    ))}
                  </Select>
                  {touched.observedIn[index].alleleOrigin &&
                  errors.observedIn[index].alleleOrigin ? (
                    <InputHelperText type="error">
                      {errors.observedIn[index].alleleOrigin}
                    </InputHelperText>
                  ) : (
                    <InputHelperText>
                      {Descriptions.alleleOrigin.slice(0, 80)}
                      {" See "}
                      <a
                        href="https://www.ncbi.nlm.nih.gov/clinvar/docs/spreadsheet/#origin"
                        target="_blank"
                      >
                        here
                      </a>
                      .<HelperText customText={Descriptions.alleleOrigin} />
                    </InputHelperText>
                  )}
                </FormGroup>
              </div>
              <div className="tw-flex tw-align-middle tw-items-center tw-justify-center tw-w-1/12">
                {state.length !== 1 && (
                  <div>
                    <FontAwesomeIcon
                      icon={faTrash}
                      onClick={() => handleRemoveObserveln(index)}
                      size="lg"
                      fixedWidth={true}
                      className="tw-px-1 tw-text-red-600 tw-cursor-pointer"
                    />
                  </div>
                )}
                {state.length === 1 && index !== 0 && (
                  <div>
                    <FontAwesomeIcon
                      icon={faTrash}
                      onClick={() => handleRemoveObserveln(0)}
                      size="lg"
                      fixedWidth={true}
                      className="tw-px-1 tw-text-red-600 tw-cursor-pointer"
                    />
                  </div>
                )}
              </div>

              {state[index].clinicalFeatures?.length !== 0 && (
                <React.Fragment>
                  <div className="tw-pt-6 tw-px-4">
                    <div className="tw-text-md"> Clinical Features</div>
                    <small className="text-muted form-text">
                      {Descriptions.clinicalFeatures.slice(0, 87)}
                      <HelperText customText={Descriptions.clinicalFeatures} />
                    </small>
                  </div>

                  <div className="tw-pt-6 tw-px-4 tw-flex tw-w-full">
                    <div className="tw-flex tw-w-11/12">
                      <div className="tw-w-4/12 tw-px-2 tw-mr-4">
                        <Label text="Database" isRequired={true} />
                      </div>
                      <div className="tw-w-4/12 tw-px-2 tw-mr-4 tw-ml-2">
                        <Label text="Id" isRequired={true} />
                      </div>
                      <div className="tw-w-4/12 tw-px-2 tw-mr-4 ">
                        <Label text="Name" isRequired={true} />
                      </div>
                      <div className="tw-flex tw-w-4/12 tw-px-2 tw-mr-4">
                        <Label text="Affected status" isRequired={true} />
                        <HelperText
                          customText={
                            Descriptions.clinicalFeaturesAffectedStatus
                          }
                        />
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              )}
              {state[index]?.clinicalFeatures?.length !== 0 &&
                x.clinicalFeatures &&
                x.clinicalFeatures.map((clin, clinindex) => {
                  const cFkey = `clinfeat-${clinindex}-${state[index].clinicalFeatures}`;
                  return (
                    <div className="tw-flex tw-w-full tw-px-4" key={cFkey}>
                      <div className="tw-flex tw-w-full tw-flex-wrap tw-px-2 tw-py-4 tw-bg-gray-200">
                        <div className="tw-flex tw-w-11/12">
                          <FormGroup
                            className="tw-w-4/12 tw-mr-4"
                            hasPadding={false}
                          >
                            <Select
                              type="select"
                              disabled={clin.name}
                              onBlur={(e) => {
                                handleBlurForAffectedStatus(
                                  e,
                                  index,
                                  clinindex
                                );
                              }}
                              name="db"
                              onChange={(e) =>
                                onValueChange(e, index, clinindex)
                              }
                              value={clin.db}
                            >
                              <option value="" />
                              <option>HP</option>
                            </Select>
                            {touched?.observedIn?.[index]?.clinicalFeatures?.[
                              clinindex
                            ]?.db &&
                              errors.observedIn?.[index]?.clinicalFeatures?.[
                                clinindex
                              ]?.db && (
                                <InputHelperText type="error">
                                  {
                                    errors.observedIn[index].clinicalFeatures[
                                      clinindex
                                    ].db
                                  }
                                </InputHelperText>
                              )}
                          </FormGroup>
                          <FormGroup
                            className="tw-w-4/12 tw-mr-4"
                            hasPadding={false}
                          >
                            <Input
                              onBlur={(e) => {
                                handleBlurForAffectedStatus(
                                  e,
                                  index,
                                  clinindex
                                );
                              }}
                              disabled={clin.name}
                              type="text"
                              name="id"
                              value={clin.id}
                              onChange={(e) =>
                                onValueChange(e, index, clinindex)
                              }
                            />
                            {touched?.observedIn?.[index]?.clinicalFeatures?.[
                              clinindex
                            ]?.id &&
                              errors.observedIn?.[index]?.clinicalFeatures?.[
                                clinindex
                              ]?.id && (
                                <InputHelperText type="error">
                                  {
                                    errors.observedIn[index].clinicalFeatures[
                                      clinindex
                                    ].id
                                  }
                                </InputHelperText>
                              )}
                          </FormGroup>
                          <FormGroup className="tw-w-4/12" hasPadding={false}>
                            <Input
                              disabled={clin.db || clin.id}
                              type="text"
                              name="name"
                              value={clin.name}
                              onBlur={(e) => {
                                handleBlurForAffectedStatus(
                                  e,
                                  index,
                                  clinindex
                                );
                              }}
                              onChange={(e) =>
                                onValueChange(e, index, clinindex)
                              }
                            />
                            {touched?.observedIn?.[index]?.clinicalFeatures?.[
                              clinindex
                            ]?.name &&
                              errors.observedIn?.[index]?.clinicalFeatures?.[
                                clinindex
                              ]?.name && (
                                <InputHelperText type="error">
                                  {
                                    errors.observedIn[index].clinicalFeatures[
                                      clinindex
                                    ].name
                                  }
                                </InputHelperText>
                              )}
                          </FormGroup>
                          <FormGroup
                            className="tw-w-4/12 tw-ml-4"
                            hasPadding={false}
                          >
                            <Select
                              type="select"
                              id={`clinicalFeaturesAffectedStatus${index}`}
                              name="clinicalFeaturesAffectedStatus"
                              onChange={(e) =>
                                onValueChange(e, index, clinindex)
                              }
                              value={clin.clinicalFeaturesAffectedStatus}
                              onBlur={(e) => {
                                handleBlurForAffectedStatus(
                                  e,
                                  index,
                                  clinindex
                                );
                              }}
                            >
                              <option value="" />
                              {CLINICAL_FEATURES_AFFECTED_STATUS.map(
                                (option) => (
                                  <option
                                    key={`${option.value}-${state[index].clinicalFeatures}`}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                )
                              )}
                            </Select>
                            {touched?.observedIn?.[index]?.clinicalFeatures?.[
                              clinindex
                            ]?.clinicalFeaturesAffectedStatus &&
                              errors.observedIn?.[index]?.clinicalFeatures?.[
                                clinindex
                              ]?.clinicalFeaturesAffectedStatus && (
                                <InputHelperText type="error">
                                  {
                                    errors.observedIn[index].clinicalFeatures[
                                      clinindex
                                    ].clinicalFeaturesAffectedStatus
                                  }
                                </InputHelperText>
                              )}
                          </FormGroup>
                        </div>
                        <div className="tw-flex tw-align-middle tw-items-center tw-justify-center tw-w-1/12">
                          {state[index].clinicalFeatures.length !== 1 && (
                            <FontAwesomeIcon
                              icon={faTrash}
                              onClick={() =>
                                handleRemoveClick(index, clinindex)
                              }
                              size="lg"
                              fixedWidth={true}
                              className="tw-px-1 tw-text-red-600 tw-cursor-pointer"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              <div className="tw-flex tw-py-4 tw-flex-col tw-w-full">
                <div className="tw-flex tw-m-4 tw-justify-center">
                  <button
                    type="button"
                    onClick={() => handleAddClick(index)}
                    className="btn btn-success"
                    disabled={
                      state[index].clinicalFeatures?.length &&
                      (state[index].clinicalFeatures[
                        state[index].clinicalFeatures?.length - 1
                      ].id === "" ||
                        state[index].clinicalFeatures[
                          state[index].clinicalFeatures?.length - 1
                        ].db === "") &&
                      state[index].clinicalFeatures[
                        state[index].clinicalFeatures?.length - 1
                      ].name === ""
                    }
                  >
                    <FontAwesomeIcon
                      icon={faPlus}
                      fixedWidth={true}
                      className="tw-px-1 tw-text-white"
                    />
                    Add Clinical Feature
                  </button>
                </div>
                <div className="tw-py-4">
                  <FormGroup className="tw-w-6/12 tw-mr-4">
                    <Label text="Clinical feature comments" />
                    <Textarea
                      type="text"
                      name="clinicalFeaturesComment"
                      value={x.clinicalFeaturesComment}
                      onChange={(e) => onValueChange(e, index)}
                    />
                    <InputHelperText>
                      {Descriptions.clinicalFeaturesComment.slice(0, 87)}
                      <HelperText
                        customText={Descriptions.clinicalFeaturesComment}
                      />
                    </InputHelperText>
                  </FormGroup>
                  <FormGroup className="tw-w-6/12 tw-mr-4">
                    <Label text="Collection method" isRequired={true} />
                    <Select
                      type="select"
                      name="collectionMethod"
                      id={`collectionMethod${index}`}
                      onChange={(e) => onValueChange(e, index)}
                      onBlur={(e) => handleBlur(e, index)}
                      value={x.collectionMethod}
                    >
                      <option value="" />
                      {CollectionMethodOptions.map((value) => (
                        <option key={value} value={value}>
                          {value}
                        </option>
                      ))}
                    </Select>
                    {touched.observedIn[index].collectionMethod &&
                    errors.observedIn[index].collectionMethod ? (
                      <InputHelperText type="error">
                        {errors.observedIn[index].collectionMethod}
                      </InputHelperText>
                    ) : (
                      <InputHelperText>
                        The method used to collect the data for each
                        observation, e.g. clinical testing or research. See{" "}
                        <a
                          href="https://www.ncbi.nlm.nih.gov/clinvar/docs/spreadsheet/#collection"
                          target="_blank"
                        >
                          here
                        </a>
                        .
                      </InputHelperText>
                    )}
                  </FormGroup>
                  <FormGroup className="tw-w-6/12 tw-mr-4">
                    <Label text="Number of individuals" />
                    <Input
                      type="text"
                      pattern="[0-9]*"
                      id={`numberOfIndividuals${index}`}
                      name="numberOfIndividuals"
                      value={x.numberOfIndividuals}
                      onChange={(e) => onValueChange(e, index)}
                      onBlur={(e) => handleBlur(e, index)}
                    />
                    {touched.observedIn[index].numberOfIndividuals &&
                    errors.observedIn[index].numberOfIndividuals ? (
                      <InputHelperText type="error">
                        {errors.observedIn[index].numberOfIndividuals}
                      </InputHelperText>
                    ) : (
                      <InputHelperText>
                        {Descriptions.numberOfIndividuals}
                      </InputHelperText>
                    )}
                  </FormGroup>
                  <FormGroup className="tw-w-6/12 tw-mr-4">
                    <Label
                      htmlFor="structVarMethodType"
                      text="Structural variant method type"
                    />
                    <Select
                      name="structVarMethodType"
                      onChange={(e) => onValueChange(e, index)}
                      value={x.structVarMethodType}
                    >
                      <option value="" />
                      {StructVarMethodTypeOptions.map((value) => (
                        <option key={value} value={value}>
                          {value}
                        </option>
                      ))}
                    </Select>
                    <InputHelperText>
                      {Descriptions.structVarMethodType}
                    </InputHelperText>
                  </FormGroup>
                </div>
              </div>
            </div>

            {state.length - 1 === index && (
              <div className="tw-flex tw-m-4 tw-justify-center">
                <button
                  type="button"
                  disabled={
                    state[index].affectedStatus === "" ||
                    state[index].alleleOrigin === "" ||
                    state[index].collectionMethod === ""
                  }
                  onClick={() => handleAddObserveln(index)}
                  className="btn btn-success"
                >
                  <FontAwesomeIcon
                    icon={faPlus}
                    fixedWidth={true}
                    className="tw-px-1 tw-text-white"
                  />
                  Add Observe In
                </button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

ObservedIn.propTypes = {
  onChangeObserveIn: PropTypes.func.isRequired,
  observedIn: ObservedInType,
  handleBlur: PropTypes.func.isRequired,
  setErrors: PropTypes.func.isRequired,
  setTouched: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ])
  ).isRequired,
  touched: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ])
  ).isRequired,
};

ObservedIn.defaultProps = {
  observedIn: null,
};

export default ObservedIn;
